import Vue from "vue"
import Vuex from "vuex"
import { HistoryEntryFromEvent, RefuelingEvent, RefuelingHistoryEntry } from "@/types/refuelingEvent"
import { User } from "@/types/user";

Vue.use(Vuex);

export interface Module1State {
    refuelings: RefuelingHistoryEntry[],
    user : User | null
}

export default new Vuex.Store<Module1State>({
    state : {
        refuelings: [],
        user: null
    },
    mutations: {
        login(state, user: firebase.User) {
            state.user = {
                isLoggedIn: true,
                email: user.email ?? "unknown"
            };
            localStorage.email = state.user.email;
        },
        logout(state) {
            state.user = {
                isLoggedIn: false,
                email: ""
            };
        },
        setRefuelingEvents(state, refuelings: RefuelingEvent[]) {
            state.refuelings = refuelings.map(x => HistoryEntryFromEvent(x)).sort((a:RefuelingHistoryEntry, b:RefuelingHistoryEntry) => b.date.getTime() - a.date.getTime());
        }
    },
    actions: {
        setRefuelingEvents(context, refuelings: RefuelingEvent[]) {
            context.commit("setRefuelingEvents", refuelings);
        }
    }
});